<template>
  <span v-html="html"></span>
</template>

<script>
export default {
  name: "user-html-area",
  props:['html']
}
</script>

<style scoped>

</style>